/**
 * @fileoverview GET handler for the "/app/braze_dashboard_config" endpoint
 */
import fetch from "@lib/fetch";
import type { DashboardConfig } from "@lib/dashboardConfig";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appBrazeDashboardConfig } from "./constants";

export const getAppBrazeDashboardConfig = reactQueryFetcherAdapter(
  appBrazeDashboardConfig,
  (signal: AbortSignal): Promise<DashboardConfig> => {
    return fetch("/app/braze_dashboard_config", "GET", {}, { signal });
  }
);
